'use client'

// The junk heap behind the east shops.
//
// He goes here more than almost anywhere (7th most-visited place, about
// eleven times a day), and until now there was nothing to see: the
// dumpsters were scenery and the rummaging was a dice roll in the sim.
//
// Sam's model, laid out in Blender AT WORLD COORDINATES: the nodes carry
// their own positions and rotations around [51.8, -14.5], which is where
// activity_junkheap already sits. So this renders at IDENTITY, like the
// ruins and the piano. Wrapping it in a group positioned at the POI would
// add the two together and put the heap eleven metres into the dock,
// which is the same baked-transform footgun the piano and the director's
// dragged props both hit.
//
// Moving the heap means moving it in Blender and re-exporting. Moving
// where he STANDS to rummage is the entity in Entities.js.

import { useSceneNodeMaterials } from '../hooks/useSceneNodeMaterials'
import { useModel } from '../hooks/useModel'

const MODEL = '/models/junk1.glb'

export function JunkHeap() {
  const { scene } = useModel(MODEL)

  useSceneNodeMaterials(scene, { roughness: 0.95 })

  // Baked transform: render at identity.
  return <primitive object={scene} />
}


export default JunkHeap
